<template>
  <v-app>
    <v-main class="d-flex fill-height pa-0">
      <div class="tutorial-screen">
        <img class="slide" :src="buildImage()" :alt="buildImage()" />
        <div class="buttons">
          <v-btn class="left black--text" color="primary" :disabled="isAtStart" fab @click="back">
            <v-icon :icon="mdiArrowLeft" x-large />
          </v-btn>

          <v-btn v-show="isAtEnd" class="right black--text" color="primary" fab @click="close">
            <v-icon :icon="mdiClose" x-large />
          </v-btn>

          <v-btn v-show="!isAtEnd" class="right black--text" color="primary" fab @click="advance">
            <v-icon :icon="mdiArrowRight" x-large />
          </v-btn>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
  import { useBrandConfig } from "@/composables/useBrand";
  import { mdiArrowLeft, mdiArrowRight, mdiClose } from "@mdi/js";
  import { computed, ref } from "vue";
  import { useRouter } from "vue-router";
  import { useAppStore } from "@/stores/app.ts";

  const router = useRouter();
  const step = ref(1);
  const { assets } = useBrandConfig();
  const slides = assets.tutorialSteps;
  const isAtStart = computed(() => step.value === 1);
  const isAtEnd = computed(() => step.value === slides.length);
  const store = useAppStore();

  const buildImage = () => {
    return `${import.meta.env.VITE_APP_S3_PUBLIC_URL}/${store.brand}/assets/tutorial/${step.value}.png`;
  };

  function advance() {
    if (step.value < slides.length) {
      step.value++;
    }
  }

  function back() {
    if (step.value > 0) {
      step.value--;
    }
  }

  function close() {
    router.push({ name: "home" });
  }
</script>

<style scoped lang="scss">
  .tutorial-screen {
    position: relative;
    width: 100%;
    height: var(--frame-height, 100vh);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slide {
    max-width: 100%;
    max-height: var(--frame-height, 95vh);
    object-fit: contain;
  }

  .buttons {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    z-index: 100;

    .left {
      float: left;
      margin-left: 20px;
    }

    .right {
      float: right;
      margin-right: 20px;
    }
  }
</style>
